import { Box, Stack } from '@mui/joy';

import TextEllipsis from 'core/elements/TextEllipsis';
import { IBellNotificationReference } from 'notifications/types';
import { Direction } from 'theme/enums';

interface IProps {
  references: IBellNotificationReference[];
}

const LINE_HEIGHT = 20;

// One line per reference; the label stays whole, the value is cut on its own. Elements, not
// strings: the core ellipsis parses strings as HTML, and the values are external or user-entered
// (a PO number).
export const NotificationReferences = ({ references }: IProps) => {
  if (!references.length) {
    return null;
  }

  return (
    <Stack spacing={0} data-testid="notificationReferences">
      {references.map(({ key, label, value }) => (
        <Stack
          key={key}
          data-testid="notificationReference"
          direction={Direction.ROW}
          spacing={0.5}
          sx={{
            minWidth: 0,
            fontSize: 'sm',
            lineHeight: `${LINE_HEIGHT}px`,
            color: 'text.secondary',
          }}
        >
          <Box component="span" sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
            {label}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <TextEllipsis
              content={
                <Box component="strong" sx={{ fontWeight: 'lg' }}>
                  {value}
                </Box>
              }
              maxRows={1}
              lineHeight={LINE_HEIGHT}
              followCursor={false}
              sx={{ minWidth: 0, overflowWrap: 'anywhere' }}
            />
          </Box>
        </Stack>
      ))}
    </Stack>
  );
};
